import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import ContactForm from "../../components/ContactForm";

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation("privacy_policy");
  const isAr = (i18n.language || "ar").startsWith("ar");

  return (
    <div style={{ ...styles.page, direction: isAr ? "rtl" : "ltr" }}>
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.title}>{t("title")}</h1>
          <p style={styles.updated}>{t("last_updated")}: {t("last_updated_value")}</p>
        </div>

        <section style={styles.card}>
          <h2 style={styles.h2}>{t("intro_title")}</h2>
          <p style={styles.p}>{t("intro_body")}</p>
        </section>

        <section style={styles.card}>
          <h2 style={styles.h2}>{t("data_we_collect_title")}</h2>
          <ul style={styles.ul}>
            <li style={styles.li}>{t("data_we_collect.items.account")}</li>
            <li style={styles.li}>{t("data_we_collect.items.orders_shipping")}</li>
            <li style={styles.li}>{t("data_we_collect.items.technical")}</li>
            <li style={styles.li}>{t("data_we_collect.items.notifications")}</li>
          </ul>
        </section>

        <section style={styles.card}>
          <h2 style={styles.h2}>{t("how_we_use_title")}</h2>
          <ul style={styles.ul}>
            <li style={styles.li}>{t("how_we_use.items.auth")}</li>
            <li style={styles.li}>{t("how_we_use.items.fulfillment")}</li>
            <li style={styles.li}>{t("how_we_use.items.support")}</li>
            <li style={styles.li}>{t("how_we_use.items.improve")}</li>
            <li style={styles.li}>{t("how_we_use.items.notifications")}</li>
          </ul>
        </section>

        <section style={styles.card}>
          <h2 style={styles.h2}>{t("sharing_title")}</h2>
          <p style={styles.p}>{t("sharing_body")}</p>
          <ul style={styles.ul}>
            <li style={styles.li}>{t("sharing.items.shipping")}</li>
            <li style={styles.li}>{t("sharing.items.payment")}</li>
            <li style={styles.li}>{t("sharing.items.analytics")}</li>
          </ul>
        </section>

        <section style={styles.card}>
          <h2 style={styles.h2}>{t("security_title")}</h2>
          <p style={styles.p}>{t("security_body")}</p>
        </section>

        <section style={styles.card}>
          <h2 style={styles.h2}>{t("retention_title")}</h2>
          <p style={styles.p}>{t("retention_body")}</p>
        </section>

        <section style={styles.card}>
          <h2 style={styles.h2}>{t("your_rights_title")}</h2>
          <ul style={styles.ul}>
            <li style={styles.li}>{t("your_rights.items.access")}</li>
            <li style={styles.li}>{t("your_rights.items.edit")}</li>
            <li style={styles.li}>{t("your_rights.items.delete")}</li>
            <li style={styles.li}>{t("your_rights.items.optout")}</li>
          </ul>
        </section>

        <section style={styles.card}>
          <h2 style={styles.h2}>{t("children_title")}</h2>
          <p style={styles.p}>{t("children_body")}</p>
        </section>

        <section style={styles.card}>
          <h2 style={styles.h2}>{t("changes_title")}</h2>
          <p style={styles.p}>{t("changes_body")}</p>
        </section>

        <section style={styles.card}>
          <h2 style={styles.h2}>{t("contact_title")}</h2>
          <p style={styles.p}>
            {t("contact_body")}{" "}
            <a href={`mailto:${t("contact_email")}`} style={styles.link}>
              {t("contact_email")}
            </a>
          </p>
        </section>
          <Box sx={{ mt: 2 }}>
            <ContactForm />
          </Box>
        <div style={styles.footerNote}>
          <small>{t("footer_note")}</small>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

const styles = {
  page: {
    minHeight: "100vh",
    background: "#f7f7fb",
    padding: "24px 12px",
  },
  container: {
    maxWidth: 900,
    margin: "0 auto",
  },
  header: {
    background: "#fff",
    borderRadius: 14,
    padding: 18,
    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
    marginBottom: 14,
  },
  title: {
    margin: 0,
    fontSize: 26,
  },
  updated: {
    margin: "6px 0 0",
    color: "#666",
    fontSize: 13,
  },
  card: {
    background: "#fff",
    borderRadius: 14,
    padding: 18,
    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
    marginBottom: 14,
  },
  h2: {
    margin: "0 0 10px",
    fontSize: 18,
  },
  p: {
    margin: 0,
    lineHeight: 1.8,
    color: "#222",
  },
  ul: {
    margin: "8px 0 0",
    paddingInlineStart: 18,
    lineHeight: 1.9,
  },
  li: {
    marginBottom: 6,
    color: "#222",
  },
  link: {
    color: "#1976d2",
    textDecoration: "none",
    fontWeight: 600,
  },
  footerNote: {
    textAlign: "center",
    color: "#666",
    marginTop: 18,
  },
};
